"use client";

import { clsx } from "clsx";
import { forwardRef, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={clsx(
          "w-full bg-[#fff7e6] text-[#1a1a1a] border-2 border-[#1a1a1a] rounded-md px-4 py-2.5 font-mono text-sm placeholder:text-[#8a7a5c] transition-all duration-200 outline-none focus:border-[#c5a83a] focus:shadow-[2px_2px_0_#c5a83a] hover:border-[#5c4a30]",
          className
        )}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export { Input };
